
import { supabase } from "@/integrations/supabase/client";
import { Review, CreateReviewData } from "@/types/review";

export const fetchReviews = async (): Promise<Review[]> => {
  // Use the secure public_reviews table with RLS protection
  const { data, error } = await supabase
    .from('public_reviews')
    .select('*')
    .order('Created at', { ascending: false });

  if (error) throw error;
  return data || [];
};

export const createReview = async (data: Omit<CreateReviewData, "Created at">): Promise<Review> => {
  console.log("Creating review with data:", data);
  
  // Get current user session
  const { data: { session } } = await supabase.auth.getSession();
  console.log("Current session:", session ? "authenticated" : "anonymous");
  
  // Prepare review data
  const reviewData = {
    ...data,
    Rating: Number(data.Rating),
    "Created at": new Date().toISOString(),
    user_id: session?.user?.id || null, // Set user_id if authenticated, null if anonymous
    is_anonymous: !session?.user?.id // Mark as anonymous if no user
  };
  
  console.log("Review data being inserted:", reviewData);

  const { data: review, error } = await supabase
    .from('Reviews')
    .insert([reviewData])
    .select()
    .maybeSingle();

  if (error) {
    console.error("Error creating review:", error);
    console.error("Error details:", {
      message: error.message,
      code: error.code,
      details: error.details,
      hint: error.hint
    });
    throw error;
  }
  
  if (!review) {
    throw new Error("Review was not created successfully");
  }
  
  console.log("Review created successfully:", review);
  
  // After creating review, sync to public_reviews table
  try {
    await supabase.rpc('sync_public_reviews');
    console.log("Public reviews synced successfully");
  } catch (syncError) {
    console.warn("Failed to sync public reviews:", syncError);
    // Don't fail the whole operation if sync fails
  }
  
  return review;
};
